import { defaultStyles } from "@visx/tooltip";

export const tooltipStyle = {
  ...defaultStyles,
  padding: 0,
  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
};
